import { render, staticRenderFns } from "./WishInfo.vue?vue&type=template&id=3e96aa06&scoped=true"
import script from "./WishInfo.vue?vue&type=script&lang=js"
export * from "./WishInfo.vue?vue&type=script&lang=js"
import style0 from "./WishInfo.vue?vue&type=style&index=0&id=3e96aa06&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e96aa06",
  null
  
)

export default component.exports